import React from "react";
import "../theme/Administracion.css";
import { AzureAD, AuthenticationState } from "react-aad-msal";
import { TableAdministracionAccesos } from "../components/TableAdministracionAccesos";
import { BtnGoBack } from "../components/Buttons/BtnGoBack";
import { useNavigate } from "react-router-dom";
import { useDynamicAuth } from "../context/AuthProviderContext"; // Importar el hook

export const AdminPageAcessos = () => {
  const navigate = useNavigate();
  const authProvider = useDynamicAuth(); // Usar el hook

  return (
    <AzureAD provider={authProvider}>
      {({ authenticationState, accountInfo }) => {
        const isAuthenticated = authenticationState === AuthenticationState.Authenticated;

        if (isAuthenticated) {
          return (
            <div className="body-color">
              <div className="title-name-admin">
                <BtnGoBack caption="Volver a administración" />
              </div>

              <TableAdministracionAccesos />
            </div>
          );
        }
      }}
    </AzureAD>
  );
};
